import type * as lazyIndex from './lazyIndex';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';
import runBeforeStart from './utils/runBeforeStart';
import { start } from 'owa-start';
import overrideBootPromises from './utils/overrideBootPromises';
import overrideRetryStrategy from './utils/overrideRetryStrategy';
import { isAnonymousUser } from 'bookings-shared/lib/c2/utils/isAnonymousUser';
import { isRunningInMetaOS } from './utils/isRunningInMetaOS';
import { hasAnonymousParam } from 'owa-config/lib/anonymousUtils';
import { setApp } from 'owa-config/lib/bootstrapOptions';
import { isMsalEnabledForBusiness } from 'owa-msaljs/lib/isMsalEnabledForBusiness';
import { getQueryStringParameters } from 'owa-querystring';
import { getWindowData } from 'owa-window-data';
import { isAnonymousSession } from 'owa-msaljs/lib/isAnonymousSession';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule(
    () => import(/* webpackChunkName: "BookWithMeBoot" */ './lazyIndex'),
    { name: 'BookWithMeBoot' }
);

const lazyBootstrap: LazyAction<typeof lazyIndex.bootstrap, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.bootstrap
);

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function setApp called at module scope is not allowed. This may cause unwanted side effects. */
setApp('BookWithMe');

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function start called at module scope is not allowed. This may cause unwanted side effects. */
start({
    app: 'BookWithMe',
    runBeforeStart,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function shouldLoadBpos called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function isRunningInMetaOS called at module scope is not allowed. This may cause unwanted side effects. */
    loadBpos: shouldLoadBpos() || isRunningInMetaOS(),
    overrideBootPromises:
        /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
         *	> Function shouldOverrideBootPromises called at module scope is not allowed. This may cause unwanted side effects.
         *	> Function isRunningInMetaOS called at module scope is not allowed. This may cause unwanted side effects. */
        shouldOverrideBootPromises() && !isRunningInMetaOS() ? overrideBootPromises : undefined,
    overrideRetryStrategy,
    bootstrap: lazyBootstrap,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function isAnonymousSession called at module scope is not allowed. This may cause unwanted side effects. */
    prefetchTokenForBoot: isAnonymousSession(),
});

function shouldLoadBpos(): boolean {
    const queryStringKeyValue = getQueryStringParameters(getWindowData().location);
    if (isMsalEnabledForBusiness() && hasMSALJsQueryParam(queryStringKeyValue)) {
        return !isAnonymousUser() || !hasAnonymousParam();
    }
    return !isAnonymousUser();
}

function shouldOverrideBootPromises(): boolean {
    const queryStringKeyValue = getQueryStringParameters(getWindowData().location);
    if (isMsalEnabledForBusiness() && hasMSALJsQueryParam(queryStringKeyValue)) {
        return isAnonymousUser() && hasAnonymousParam();
    }

    return isAnonymousUser();
}

function hasMSALJsQueryParam(queryStringKV: {}) {
    return Object.keys(queryStringKV).indexOf('ismsaljsauthenabled') >= 0;
}
